/**
 * Shared motion-library presets used across the site. These mirror the CSS
 * tokens in `app/globals.css` (`--ease-out-quint`, `--duration-base`, etc.) so
 * JS-driven animations and CSS transitions land on the same curves.
 *
 * Usage:
 *   <motion.div {...FADE_UP} transition={FADE_TRANSITION} />
 *   <motion.div variants={STAGGER_CONTAINER} initial="hidden" animate="show">
 *     <motion.div variants={STAGGER_ITEM} />
 *   </motion.div>
 *
 * For most pages prefer the `<Reveal>` and `<Stagger>` primitives in
 * `components/motion`, which wrap these presets and short-circuit on
 * `prefers-reduced-motion`.
 */

export const EASE_OUT_QUINT = [0.22, 1, 0.36, 1] as const
export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1] as const

export const FADE_UP = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
} as const

export const FADE_TRANSITION = {
  duration: 0.24,
  ease: EASE_OUT_QUINT,
} as const

export const FADE_TRANSITION_SOFT = {
  duration: 0.42,
  ease: EASE_OUT_EXPO,
} as const

// Critically-damped-ish spring for hover lifts: crisp rise, no wobble.
export const HOVER_SPRING = {
  type: "spring",
  stiffness: 300,
  damping: 26,
  mass: 0.6,
} as const

export const STAGGER_CONTAINER = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.06, delayChildren: 0.04 },
  },
} as const

export const STAGGER_ITEM = {
  hidden: { opacity: 0, y: 10 },
  show: {
    opacity: 1,
    y: 0,
    transition: FADE_TRANSITION,
  },
} as const
